import { Controller } from "@hotwired/stimulus"

// Resolving emails the customer and closing hides the reply form, so saving
// either asks first (independent QA). Only when it is a real change: saving the
// status a ticket already has does nothing, so there is nothing to confirm.
export default class extends Controller {
  static targets = ["select"]
  static values = { current: String, messages: Object }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasSelectTarget) return

    const chosen = this.selectTarget.value
    const message = chosen !== this.currentValue ? this.messagesValue[chosen] : null
    if (message) {
      this.element.dataset.turboConfirm = message
      this.element.dataset.confirmVariant = "primary"
    } else {
      delete this.element.dataset.turboConfirm
    }
  }
}
